import React from 'react'
import Slider from "react-slick";
import nrt_slider_img_1 from '../../assets/images/nrt_slider_img_1.png'
import nrt_slider_img_2 from '../../assets/images/nrt_slider_img_2.png'
import nrt_slider_img_3 from '../../assets/images/nrt_slider_img_3.png'
import nrt_slider_img_4 from '../../assets/images/nrt_slider_img_4.png'
import mobile_slider_img_1 from '../../assets/images/mobile_slider_img_1.png'
import mobile_slider_img_2 from '../../assets/images/mobile_slider_img_2.png'
import mobile_slider_img_3 from '../../assets/images/mobile_slider_img_3.png'
import mobile_slider_img_4 from '../../assets/images/mobile_slider_img_4.png'
const HomeSlider = () => {
  var settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <>
      <section className='home-slider hidden lg:block'>

        <Slider {...settings}>
          <div className='h-auto'>
            <img src={nrt_slider_img_1} alt="" />
          </div>
          <div className='h-auto'>
            <img src={nrt_slider_img_2} alt="" />
          </div>
          <div className='h-auto'>
            <img src={nrt_slider_img_3} alt="" />
          </div>
          <div className='h-auto'>
            <img src={nrt_slider_img_4} alt="" />
          </div>

        </Slider>

      </section>
      <section className='home-slider lg:hidden'>

        <Slider {...settings}>
         
            <img src={mobile_slider_img_1} alt="" />
         
         
            <img src={mobile_slider_img_2} alt="" />
         
         
            <img src={mobile_slider_img_3} alt="" />
         
         
            <img src={mobile_slider_img_4} alt="" />
         

        </Slider>
      </section>

    </>
  )
}

export default HomeSlider